export const Component = config => {
  return target => {
    config.controller = target;
    return config;
  };
};



// WEBPACK FOOTER //
// ./src/utils/component-decorator.js